<template>
  <BaseModal
    name="questionModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="() => {}"
    @before-open="openModal"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('questionModal')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-app-modal__title">{{ title || "Автопополнение" }}</div>

        <div v-html="text"></div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('questionModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Закрыть окно
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },
  props: ["title"],
  data() {
    return {
      text: "",
    };
  },
  methods: {
    openModal({ params }) {
      this.text = params?.text;
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
